export enum ModeLevelFormatter {
  BADGE = 'BADGE',
  CARD = 'CARD'
}
